import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      welcome: "Welcome to My Portfolio",
      
      history: "History",
      projects: "Projects",

      play: "Play",
      pause: "Pause",

      contact: "Contact Me",
      projectDescription: "Got a project waiting to be realized? Let's collaborate and make it happen!",
      yourName: "Your Name",
      namePlaceholder: "What's your name?",
      nameError: "Please enter your name",
      emailPhone: "Email / Phone",
      emailPhonePlaceholder: "How can I reach you?",
      emailError: "Please enter your email or phone number",
      message: "Message",
      messagePlaceholder: "Send me any inquiries or questions",
      messageError: "Please enter the message",
      send: "Send",

      expertise: "Expertise",
      fullStack: "Full Stack Web Development",
      fullStackDescription: "I have built a diverse array of web applications from scratch using modern technologies such as React and Vue. I have a strong proficiency in the SDLC process and frontend + backend development.",
      techStack: "Tech stack:",
      devOps: "DevOps & Automation",
      devOpsDescription: "Once the application is built, I help clients set up DevOps testing, CI/CD pipelines, and deployment automation to support the successful Go-Live.",
      gameDev: "Game Development & Web3",
      gameDevDescription: "Stay creative in the market by leveraging the latest technology in your projects. I have great experience building Web3 games that utilized the true potential of a smart contract (Crypto and NFTs).",
  
      careerHistory: "Career History",
      webEngineer: "Web Engineer",
      tacoma: "Tacoma, WA",
      webEngineerDetails: "Old Systems Renovation, Frontend Development, Backend Development, User Experience",
      fullstackIntern: "Fullstack Intern",
      lacey: "Lacey, WA",
      fullstackInternDetails: "Full-stack Development, API Development, Web Development, Customer Collaboration",
      iosDeveloper: "iOS Developer",
      charlotte: "Charlotte, NC",
      iosDeveloperDetails: "Mobile Development, Swift, Teamwork, Testing",
      fullstackEngineer: "Full Stack Engineer",
      renton: "Renton, VA",
      fullstackEngineerDetails: "Full-stack Web Development, Java, Hibernate, Spring-Boot, Microservices",

      footerMessage: "A portfolio designed & built by",
      footerWithLove: "with 💜",

      aboutName: "Alec Michel",
      aboutTitle: "Full Stack Engineer",

       // Projects Section
       personalProjects: "Personal Projects",
       smallerProjects: "Smaller Projects/Fight Scenes",
       castleClimb: "Castle Climb",
       castleClimbDescription: "The Game that will climb the world.",
       castleClimbDetails: "+3 year Team Game Project that implements Unity multiplayer, a node.js web api, mongodb and mariadb database, and Smart Contracts 'Playable'",
       redMoon: "Red Moon",
       redMoonDescription: "Designed, developed, and launched a 3D online multiplayer shooter game with C#, Unity and Photon. You must download and unzip both gamelauncher the launcher, to play the game. 'Playable with propper setup'",
       pokemon6v6: "Pokemon 6v6",
       pokemon6v6Description: "My first masterpiece I ever fully created, however it was on an old programming system, so the game is no longer playable, but here is a demonstration of what it was like. 'Video Demo'",
       autoDuo: "Auto Duo",
       autoDuoDescription: "Older 2019 Project that used Selenium to blaze through an older version of a Japanese Duolingo Lesson. Was used to gain the highest score in the world at the time without hurting my fingers. 'No Demo'",
       
       predictingWineQuality: "Predicting Wine Quality Model",
       predictingWineQualityDescription: "This was a small project utilizing AI to predict wine quality. 'No Demo'",
       broomBattle: "Broom Battle",
       broomBattleDescription: "Me and my brother try to kill each other with brooms. 'Video'",
       dawgFight: "Dawg Fight",
       dawgFightDescription: "I battle a homeless guy in the park with my dog, kinda like a Pokemon battle. 'Video'",
       ballFetch: "Ball Fetch",
       ballFetchDescription: "Me and my brothers and some dogs have a race to see who can fetch a ball that is thrown nice and hard. 'Video'",
       twitchChatVsPlayer: "Twitch Chat vs Player",
       twitchChatVsPlayerDescription: "Created several python scripts that allows Twitch Chat to interact with the Twitch Players game. Messes with the Twitch Streamer while they're playing!'Disclaimer, this video demonstrates the general idea of what the scripts does'",
       schubertCelloQuintet: "Schubert Cello Quintet",
       schubertCelloQuintetDescription: "My family performs the Schubert Cello Quintent I, Allegro ma...",
 
      // Add other English text here
    },
  },
  jp: {
    translation: {
      welcome: "私のポートフォリオへようこそ",

      history: "経歴",
      projects: "プロジェクト",

      play: "再生",
      pause: "一時停止",

      contact: "お問い合わせ",
      projectDescription: "実現を待っているプロジェクトはありますか？一緒に協力して実現しましょう！",
      yourName: "名前",
      namePlaceholder: "お名前を教えてください",
      nameError: "お名前を入力してください",
      emailPhone: "メール / 電話番号",
      emailPhonePlaceholder: "ご連絡先を教えてください",
      emailError: "メールアドレスまたは電話番号を入力してください",
      message: "メッセージ",
      messagePlaceholder: "お問い合わせや質問をお送りください",
      messageError: "メッセージを入力してください",
      send: "送信",

      expertise: "専門分野",
      fullStack: "フルスタックウェブ開発",
      fullStackDescription: "ReactやVueなどの最新技術を使用して、多様なウェブアプリケーションをゼロから構築しました。SDLCプロセスおよびフロントエンド＋バックエンド開発において高い専門性を持っています。",
      techStack: "技術スタック：",
      devOps: "DevOps & 自動化",
      devOpsDescription: "アプリケーションを構築した後、クライアントがDevOpsテスト、CI/CDパイプライン、デプロイ自動化をセットアップするのをサポートし、成功するGo-Liveを実現します。",
      gameDev: "ゲーム開発 & Web3",
      gameDevDescription: "プロジェクトで最新技術を活用し、市場で創造性を維持しましょう。スマートコントラクト（暗号通貨とNFT）の真の可能性を活用したWeb3ゲームの開発経験があります。",

      careerHistory: "職歴",
      webEngineer: "ウェブエンジニア",
      tacoma: "タコマ, ワシントン州",
      webEngineerDetails: "旧システムのリノベーション、フロントエンド開発、バックエンド開発、ユーザーエクスペリエンス",
      fullstackIntern: "フルスタックインターン",
      lacey: "レイシー, ワシントン州",
      fullstackInternDetails: "フルスタック開発、API開発、ウェブ開発、顧客との協力",
      iosDeveloper: "iOS開発者",
      charlotte: "シャーロット, ノースカロライナ州",
      iosDeveloperDetails: "モバイル開発、Swift、チームワーク、テスト",
      fullstackEngineer: "フルスタックエンジニア",
      renton: "レントン, バージニア州",
      fullstackEngineerDetails: "フルスタックウェブ開発、Java、Hibernate、Spring-Boot、マイクロサービス",
   

      footerMessage: "ポートフォリオは以下によってデザインおよび構築されました：",
      footerWithLove: "💜を込めて",

      aboutName: "アレック・ミシェル",
      aboutTitle: "フルスタックエンジニア",

      // Projects Section
      personalProjects: "個人プロジェクト",
      smallerProjects: "小規模プロジェクト/戦闘シーン",
      castleClimb: "キャッスルクライム",
      castleClimbDescription: "世界を登るゲーム。",
      castleClimbDetails: "Unityマルチプレイヤー、Node.js Web API、MongoDB、MariaDBデータベース、スマートコントラクトを実装した3年以上のチームプロジェクト 'プレイ可能'",
      redMoon: "レッドムーン",
      redMoonDescription: "C#、Unity、Photonを使用して3Dオンラインマルチプレイヤーシューターゲームを設計、開発、公開。ゲームをプレイするには、ゲームランチャーをダウンロードして解凍する必要があります。 '適切な設定でプレイ可能'",
      pokemon6v6: "ポケモン6v6",
      pokemon6v6Description: "私が完全に作成した最初の傑作ですが、古いプログラミングシステムで作成されたため、ゲームはもうプレイできませんが、デモ映像でその内容を紹介しています。 'ビデオデモ'",
      autoDuo: "オートデュオ",
      autoDuoDescription: "2019年の古いプロジェクトで、Seleniumを使用して日本語版Duolingoのレッスンをクリア。指を傷めることなく世界最高スコアを獲得するために使用されました。 'デモなし'",
      
      predictingWineQuality: "ワインの品質予測モデル",
      predictingWineQualityDescription: "AIを使用してワインの品質を予測する小さなプロジェクト。 'デモなし'",
      broomBattle: "箒バトル",
      broomBattleDescription: "私と兄が箒で戦うシーン。 'ビデオ'",
      dawgFight: "ドッグファイト",
      dawgFightDescription: "公園でホームレスの男と戦い、犬でポケモンバトルのように戦う。 'ビデオ'",
      ballFetch: "ボールの取り合い",
      ballFetchDescription: "私と兄弟、犬たちがボールを取り合うレース。 'ビデオ'",
      twitchChatVsPlayer: "Twitchチャット対プレイヤー",
      twitchChatVsPlayerDescription: "TwitchチャットがTwitchプレイヤーのゲームに影響を与えるPythonスクリプトを作成。ゲーム中にTwitchストリーマーを邪魔します！'このビデオではスクリプトの一般的なアイデアを紹介'",
      schubertCelloQuintet: "シューベルト・チェロ五重奏",
      schubertCelloQuintetDescription: "私の家族がシューベルトのチェロ五重奏を演奏します。"
      // Add other Japanese text here
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
